import React, { useState } from 'react';
import './AchievementsManagement.css';
import IconPicker from '../IconPicker';

/**
 * 🎯 ACHIEVEMENTS MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Achievements Banner nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - 3 Achievement Items kompakt zusammengefasst
 * - Icon-Management für jedes Achievement
 * - Spezifische Klassennamen
 */
function AchievementsManagement({
    editData,
    handleInputChange
}) {
    const [isExpanded, setIsExpanded] = useState(false);
    
    // Icon Picker States - Intern verwaltet
    const [showIconPicker1, setShowIconPicker1] = useState(false);
    const [showIconPicker2, setShowIconPicker2] = useState(false);
    const [showIconPicker3, setShowIconPicker3] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    // Icon Selection Handler
    const handleIconSelect = (icon, achievementIndex) => {
        const iconSrc = icon?.src || icon; // Handle both icon object and direct src
        const fakeEvent = {
            target: {
                name: `achievement${achievementIndex}Icon`,
                value: iconSrc,
                type: 'text'
            }
        };
        handleInputChange(fakeEvent);
        
        // Close the respective icon picker
        if (achievementIndex === 1) setShowIconPicker1(false);
        if (achievementIndex === 2) setShowIconPicker2(false);
        if (achievementIndex === 3) setShowIconPicker3(false);
    };

    const achievements = [
        {
            number: 1,
            titleField: 'achievement1Number',
            textField: 'achievement1Text',
            iconField: 'achievement1Icon',
            showIconPicker: showIconPicker1,
            setShowIconPicker: setShowIconPicker1
        },
        {
            number: 2,
            titleField: 'achievement2Number',
            textField: 'achievement2Text',
            iconField: 'achievement2Icon',
            showIconPicker: showIconPicker2,
            setShowIconPicker: setShowIconPicker2
        },
        {
            number: 3,
            titleField: 'achievement3Number',
            textField: 'achievement3Text',
            iconField: 'achievement3Icon',
            showIconPicker: showIconPicker3,
            setShowIconPicker: setShowIconPicker3
        }
    ];

    return (
        <div className="achievements-management">
            {/* Toggle Header */}
            <div 
                className={`achievements-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="achievements-header-content">
                    <div className="achievements-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 1L10 5H14L11 8L12 12L8 10L4 12L5 8L2 5H6L8 1Z" stroke="currentColor" strokeWidth="1.2"/>
                            <circle cx="8" cy="6" r="1" fill="currentColor"/>
                        </svg>
                    </div>
                    <h3 className="achievements-header-title">Achievements</h3>
                    <div className="achievements-counter">
                        3
                    </div>
                </div>
                <div className={`achievements-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="achievements-content">
                    {/* Achievements Grid */}
                    <div className="achievements-grid">
                        {achievements.map((achievement, index) => (
                            <div key={achievement.number} className="achievement-edit-card">
                                {/* Card Header */}
                                <div className="achievement-card-header">
                                    <div className="achievement-card-title">
                                        <div className="achievement-card-number">{achievement.number}</div>
                                        <span>Achievement</span>
                                    </div>
                                </div>

                                {/* Icon Section */}
                                <div className="achievement-icon-section">
                                    <div className="achievement-icon-preview-container">
                                        <div className="achievement-icon-preview">
                                            {editData[achievement.iconField] ? (
                                                <img
                                                    src={editData[achievement.iconField]}
                                                    alt={`Achievement ${achievement.number} Icon`}
                                                    className="achievement-icon-image"
                                                />
                                            ) : (
                                                <div className="achievement-icon-placeholder">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M8 3V13M3 8H13" stroke="#dee2e6" strokeWidth="1.5" strokeLinecap="round"/>
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Icon Controls */}
                                    <div className="achievement-icon-controls">
                                        <button
                                            onClick={() => achievement.setShowIconPicker(!achievement.showIconPicker)}
                                            className={`achievement-icon-control-btn picker ${achievement.showIconPicker ? 'active' : ''}`}
                                            title="Choose from library"
                                        >
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M7 2L9 6H11L7 12L5 8H3L7 2Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
                                            </svg>
                                        </button>

                                        {editData[achievement.iconField] && (
                                            <button
                                                onClick={() => {
                                                    const fakeEvent = {
                                                        target: {
                                                            name: achievement.iconField,
                                                            value: '',
                                                            type: 'text'
                                                        }
                                                    };
                                                    handleInputChange(fakeEvent);
                                                }}
                                                className="achievement-icon-control-btn clear"
                                                title="Clear icon"
                                            >
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                                                </svg>
                                            </button>
                                        )}
                                    </div>

                                    {/* Icon Picker */}
                                    {achievement.showIconPicker && (
                                        <div className="achievement-icon-picker-container">
                                            <div className="achievement-icon-picker-content">
                                                <IconPicker
                                                    onSelect={(selectedIcon) => handleIconSelect(selectedIcon, achievement.number)}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Text Fields */}
                                <div className="achievement-content-section">
                                    <label className="achievement-field-label">Number</label>
                                    <input
                                        type="text"
                                        value={editData[achievement.titleField] || ''}
                                        onChange={(e) => {
                                            const fakeEvent = {
                                                target: {
                                                    name: achievement.titleField,
                                                    value: e.target.value,
                                                    type: 'text'
                                                }
                                            };
                                            handleInputChange(fakeEvent);
                                        }}
                                        placeholder="Enter achievement number..."
                                        className="achievement-input"
                                    />
                                </div>

                                <div className="achievement-content-section">
                                    <label className="achievement-field-label">Description</label>
                                    <textarea
                                        value={editData[achievement.textField] || ''}
                                        onChange={(e) => {
                                            const fakeEvent = {
                                                target: {
                                                    name: achievement.textField,
                                                    value: e.target.value,
                                                    type: 'text'
                                                }
                                            };
                                            handleInputChange(fakeEvent);
                                        }}
                                        placeholder="Enter achievement text..."
                                        className="achievement-textarea"
                                        rows={3}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default AchievementsManagement;
